import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { discountAdapter } from 'shop/adapter/discount.adapter';
import { AppThunk } from 'store';

import { IDiscount } from '../../entities/discount.entity';
import { DiscountApi } from '../api/discount.api';
import {
  fetchDiscountFailed,
  fetchDiscountSuccedded,
  fetchUpdateDiscount,
} from '../slices/discount.slice';

export const updateDiscountRequest = (
  id: string,
  data: Partial<IDiscount>,
  onError: (err?: AxiosError) => void,
): AppThunk => async (dispatch: Dispatch<any>) => {
  let response: AxiosResponse<IDiscount> | null = null;
  dispatch(fetchUpdateDiscount(id));

  try {
    response = await DiscountApi.updateDiscount(id, data);
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;
    if (responseError?.data) {
      const {
        data: { statusCode, message },
      } = responseError;
      dispatch({
        key: 'update',
        error: {
          isAxiosError,
          message,
          name,
          code: statusCode,
          stack,
        },
      });
      onError(err);
      return;
    }
  }

  if (response && response.data && response.data.id) {
    const discount = discountAdapter([response.data]);
    dispatch(fetchDiscountSuccedded({ key: 'update', data: discount }));
    onError(undefined);
    return;
  }

  dispatch(
    fetchDiscountFailed({
      key: 'update',
      error: {
        isAxiosError: false,
        message: '',
        name: '',
        code: '404',
        stack: '',
      },
    }),
  );
  onError(undefined);
};
